// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1PermissionsCreateSchema } from './v1/permissions/createSchema';
import { v1ResourcePermissionSchema } from './v1/resourcePermissionSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const createResourcePermissionsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const createResourcePermissionsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Permissions created successfully
 */
export const createResourcePermissions201Schema = z.lazy(() => v1ResourcePermissionSchema);

/**
 * @description Unauthorized
 */
export const createResourcePermissions401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const createResourcePermissionsMutationRequestSchema = z.lazy(() => v1PermissionsCreateSchema);

export const createResourcePermissionsMutationResponseSchema = z.lazy(() => createResourcePermissions201Schema);
